import { Notice } from '@genial/components';
import { Utils } from '@genial/utils';
import { useRecoilValue } from 'recoil';

import { masterState } from '../../../../store/master/atom';

export const AllAdvisorsOrAllPartnersWarning = () => {
  const { selectedAdvisor, selectedPartner } = useRecoilValue(masterState);
  const isAllAdvisors = selectedAdvisor === 0;
  const isAllPartners = selectedPartner === 0;

  if (!isAllAdvisors && !isAllPartners) {
    return null;
  }

  return (
    <Notice
      backgroundColor={Utils.ColorToken.WithOpacity('feedback.attention.lightest', 0.4)}
      textObjects={[
        { text: 'Atenção:', variant: 'bold' },
        {
          text: ' A visualização ‘Todas os assessores’ e ‘Todas as filiais’ não está disponível nesta tela. Selecione sua filial inicial e o assessor ao qual o cliente está alocado ou busque por algum dado do cliente no campo superior esquerdo.',
          variant: 'regular',
        },
      ]}
    />
  );
};
